<template>
  <div id="docs">
    <div class="ma-4" v-if="doc_text_html">
      <div v-html="doc_text_html"></div>
    </div>
  </div>
</template>

<script>
const TermsTextURL = require("file-loader!../assets/TermsText.md");
const PrivacyTextURL = require("file-loader!../assets/PrivacyText.md");
const ImprintTextURL = require("file-loader!../assets/ImprintText.md");
import markdownItIcons from "markdown-it-icons";

const md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});
md.use(markdownItIcons, "font-awesome");
import "markdown-it-icons/dist/index.css";

export default {
  name: "LegalDocView",
  mounted() {
    this.update_data(this.$route.path);
  },
  methods: {
    update_data(path) {
      var doctype = path.split("/").pop();
      switch (doctype) {
        case "terms":
          this.fetchText(TermsTextURL);
          break;
        case "privacy":
          this.fetchText(PrivacyTextURL);
          break;
        case "imprint":
          this.fetchText(ImprintTextURL);
          break;
        default:
          this.doc_text_html = "error: document not found";
      }
    },
    fetchText(textURL) {
      var oReq = new XMLHttpRequest();
      oReq.addEventListener("load", (data) => {
        this.doc_text_html = md.render(data.target.responseText);
      });
      oReq.open("GET", textURL);
      oReq.send();
    },
  },
  data: function() {
    return {
      doc_text_html: null,
    };
  },
};
</script>

<style lang="scss" scoped></style>
